export const types =  {
  REQUEST: "REQUEST",
  RESPONSE: "RESPONSE",
  FAILURE: "FAILURE"
 }
